import LegalLayout from '@/layouts/LegalLayout';

export default function Cookies() {
  return (
    <div className="font-normal">
      <h3>Introducción</h3>

      <p>
        Persona utiliza cookies y tecnologías similares en nuestro Sitio y
        Servicio para operar y administrar nuestro Sitio y el Servicio,
        recopilar datos de uso y rendimiento y brindarle una experiencia
        personalizada con Persona. Esto se describe en más detalle a
        continuación.
      </p>

      <p>
        Esta Política de cookies proporciona información sobre cómo y cuándo
        usamos cookies y tecnologías similares y las opciones que tiene. Forma
        parte de la Política de privacidad de Persona. Los términos en mayúscula
        utilizados en esta Política pero no definidos tienen el significado
        establecido en nuestra Política de privacidad, que también incluye
        detalles sobre (i) por qué y cómo Persona recopila, usa y almacena los
        Datos personales que recopilamos o recibimos a través del Sitio o el
        Servicio. , (ii) la base legal sobre la cual se procesan los Datos
        personales, y (iii) cuáles son sus derechos y nuestras obligaciones en
        relación con sus Datos personales. Lea nuestra Política de privacidad
        para obtener información sobre estos artículos.
      </p>
    </div>
  );
}

Cookies.layoutProps = {
  Layout: LegalLayout,
  pageTitle: 'Política de cookies',
};
